export const STEPS = [
  {
    id: "checks",
    titleKey: "checks",
    fallback: "Checks",
    component: "TenantAdditionalChecks",
    always: true,
    hideInSidebar: true,
  },
  {
    id: "basic",
    titleKey: "details",
    fallback: "details",
    component: "BasicInfoModal",
    always: true,
  },
  {
    id: "identity",
    titleKey: "identity",
    fallback: "Identity",
    component: "AuthenticateYourId",
    needs: "TENANT_KYC",
  },
  {
    id: "documents",
    titleKey: "documents",
    fallback: "Documents",
    component: "TenantChecksUploadDocument",
    always: true,
  },
  {
    id: "financial",
    titleKey: "financialStudy",
    fallback: "Financial study",
    component: "TenantChecksIncomeModel",
    needs: "TENANT_SKOR",
  },
  {
    id: "guarantor",
    titleKey: "group",
    fallback: "Group",
    component: "GuarantorInviteSection",
    always: true,
  },
];

export const getVisibleSteps = (additionalInfo = []) =>
  STEPS.filter(
    (s) =>
      s.always ||
      (typeof s.needs === "function"
        ? s.needs(additionalInfo)
        : additionalInfo.includes(s.needs))
  );

export const getSidebarSteps = (additionalInfo = []) =>
  getVisibleSteps(additionalInfo).filter((s) => !s.hideInSidebar);
